const CAP40 = {
  "id": 312,
  "title": "La Dificultad de Minería",
  "slug": "dificultad-de-mineria",
  "type": "lesson",
  "category": "bitcoin-avanzado",
  "level": "advanced",
  "preview": "Qué es la dificultad de minería, cómo se ajusta en Bitcoin y por qué es un elemento crítico para la seguridad y estabilidad del protocolo.",
  "sections": [
    {
      "heading": "¿Qué es la dificultad de minería?",
      "text": [
        "Bitcoin tiene una complejidad de minería dinámica. Esto significa que la dificultad para minar un bloque no siempre es igual: a veces aumenta y otras disminuye.",
        "La palabra “dificultad” funciona como una unidad de medida que indica qué tan difícil es encontrar el hash válido para un bloque dentro del proceso de minería.",
        "En Bitcoin, el protocolo establece que debe minarse un bloque cada 10 minutos en promedio. Para lograrlo, los mineros deben encontrar un nonce que permita producir un hash con las características requeridas por la red.",
        "Si un minero obtiene demasiada potencia de cálculo (por ejemplo mediante miles de ASIC), podría encontrar bloques mucho más rápido, rompiendo este promedio de 10 minutos. Esto afectaría la emisión programada de bitcoin, pudiendo adelantar la producción total de BTC.",
        "Para evitarlo, Bitcoin implementa uno de sus mecanismos esenciales: el **reajuste periódico de la dificultad de minería**, que aumenta o disminuye el nivel de dificultad del problema matemático según sea necesario."
      ]
    },
    {
      "heading": "¿Cada cuánto se reajusta la dificultad en Bitcoin?",
      "text": [
        "El ajuste de dificultad depende de cada blockchain, pero en Bitcoin ocurre de forma automática cada **2,016 bloques**, lo cual equivale aproximadamente a dos semanas.",
        "En todo nodo de Bitcoin existe un fragmento de código preparado para este cálculo. Cada vez que se alcanzan los 2,016 bloques minados desde el último ajuste, todos los nodos recalculan la nueva dificultad que se aplicará para la siguiente etapa de minería.",
        "El objetivo es mantener el tiempo promedio de producción de bloques en **10 minutos**."
      ]
    },
    {
      "heading": "¿Cómo se calcula la dificultad de minería?",
      "text": [
        "La dificultad es independiente del número o valor monetario de las transacciones, pero sí se correlaciona directamente con el **poder de hash total de la red**.",
        "La fórmula clásica es:",
        "",
        "dificultad = dificultad_1_target / current_target",
        "",
        "El objetivo (target) es un número de 256 bits. `dificultad_1_target` representa el objetivo estándar utilizado históricamente, donde los primeros 32 bits son cero y el resto uno (pdiff).",
        "Debido a la forma en que el protocolo Bitcoin representa los objetivos, muchos clientes aproximan la dificultad utilizando un formato conocido como “bdiff”.",
        "La red compara el tiempo real que se tardó en minar los últimos 2,016 bloques con el tiempo esperado (20,160 minutos = 10 minutos por bloque × 2,016).",
        "A partir de esa comparación, se ajusta la dificultad al alza o a la baja para estabilizar nuevamente el ritmo de creación de bloques."
      ]
    },
    {
      "heading": "¿Por qué es importante la dificultad?",
      "text": [
        "La dificultad cumple varias funciones críticas dentro del protocolo Bitcoin:",
        "- Mantiene un ritmo constante y predecible en la emisión de nuevas monedas.",
        "- Garantiza que el tiempo promedio por bloque sea estable, evitando riesgos de seguridad.",
        "- Impide que mineros con demasiada potencia dominen el proceso de minería.",
        "Cuando el precio de BTC sube, más mineros se unen, aumentando el hashrate y haciendo que la dificultad suba también. De esta forma, se mantiene constante el ritmo de producción de nuevos bloques, preservando la integridad económica del sistema."
      ]
    }
  ]
}

export default CAP40;
